import React from "react";
import { SFStack, SFUseStyled, SFIconButton, SFIcons } from "@sf-core";

const { styled } = SFUseStyled();

const STyledStack = styled(SFStack)(({ theme }) => ({
  borderRadius: theme.spacing(0.5),
  border: `2px solid ${theme.palette.grey400.main}`,
  background: theme.palette.grey550.main,
  position: "fixed",
  bottom: 50,
  right: 50,
}));

const Divider = styled("div")(({ theme }) => ({
  width: 1,
  borderLeft: `1px solid ${theme.palette.grey400.main}`,
  opacity: 0.4,
}));

const NavigationButtons = ({ currentComponentRef, disableNext }) => {
  return (
    <STyledStack direction="row">
      <SFIconButton
        variant="transparent"
        onClick={() => {
          if (currentComponentRef.current) {
            currentComponentRef.current.onStepClose(true);
          }
        }}
      >
        <SFIcons.SFArrowUpRoundedIcon />
      </SFIconButton>
      <Divider />
      <SFIconButton
        variant="transparent"
        disabled={disableNext}
        onClick={() => {
          if (currentComponentRef.current) {
            currentComponentRef.current.onStepClose();
          }
        }}
      >
        <SFIcons.SFArrowDownRoundedIcon />
      </SFIconButton>
    </STyledStack>
  );
};

export default NavigationButtons;
